import APriceTableRow from './index.vue';

APriceTableRow.install = app => {
  app.component(APriceTableRow.name, APriceTableRow);
};

export default APriceTableRow;
